import { render, staticRenderFns } from "./DetailProyek.vue?vue&type=template&id=46302dd6&scoped=true"
import script from "./DetailProyek.vue?vue&type=script&lang=js"
export * from "./DetailProyek.vue?vue&type=script&lang=js"
import style0 from "./DetailProyek.vue?vue&type=style&index=0&id=46302dd6&prod&scoped=true&lang=css"
import style1 from "./DetailProyek.vue?vue&type=style&index=1&id=46302dd6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46302dd6",
  null
  
)

export default component.exports